/**
 * Which RAIL tab a watch was started from — a MODULE ref, for exactly the
 * reason `navigateRef` is one.
 *
 * `rail/tournament/usePanelContext.ts`'s `watchTournamentGame` captures the
 * rail's current tab (`railTab`) as it starts a watch — the panel that started
 * it unmounts the moment the watched board owns the surface (the rail swaps to
 * the MOVES tab), so component state would be gone by the time "Stop watching"
 * needs it — and `rail/live/Toolbar/tiles/StopWatchingTile` / the spectator
 * result card's own exit (`overlay/ResultOverlay`) consume it.
 *
 * Before fix G (2026-10-06) this held the full-width tournament PAGE's own tab
 * (`V2TournamentTab`), because that page — not the rail — was what disappeared
 * under a watch. The page is gone; the rail is the one surface now, so this
 * holds `V2RailTab` directly and the two capture/consume sides need no mapping
 * between two tab vocabularies any more.
 */
import type {V2RailTab} from '../theme/useV2Ui';

/** the tab a watch was started from, or null when nothing was captured. */
export const watchSourceTabRef: {current: V2RailTab | null} = {
  current: null,
};

/**
 * Read it, clear it, default to 'pairings' — the closest rail equivalent of
 * the old screen's own fallback tab ('games', TournamentPlay's `games`/
 * `ArenaGames` tab, which is what `tabsFor` now labels 'pairings' in a Swiss
 * and 'Games' in an arena).
 */
export const takeWatchSourceTab = (): V2RailTab => {
  const tab = watchSourceTabRef.current;
  watchSourceTabRef.current = null;
  return tab || 'pairings';
};

export default watchSourceTabRef;
